import { render, staticRenderFns } from "./BaseHover.vue?vue&type=template&id=ebeb53ae&scoped=true&"
import script from "./BaseHover.vue?vue&type=script&lang=js&"
export * from "./BaseHover.vue?vue&type=script&lang=js&"
import style0 from "./BaseHover.vue?vue&type=style&index=0&id=ebeb53ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebeb53ae",
  null
  
)

export default component.exports